export const getBlockExplorerLink = (chainId: number) => {
  if (chainId === 1) return "https://etherscan.io";
  return "https://etherscan.io";
};
